export default __webpack_public_path__ + "static/media/loading.08db76a4.svg";